module.exports = __webpack_public_path__ + "static/media/logo-chubb-insured.ee2e1707.svg";